import { useState, useEffect, useRef } from 'react';

export const useSwiperRef = <T extends HTMLElement>(): [T | null, React.RefObject<T>] => {
    const [element, setElement] = useState<T | null>(null)
    const ref = useRef<T>(null)

    useEffect(() => {
        if (ref.current) {
            setElement(ref.current)
        }
    }, [])

    return [element, ref]
}